var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:_vm.qrcode,staticStyle:{"padding":"5px","display":"flex","justify-content":"center"},attrs:{"id":_vm.qrCode}}),_c('p',{staticClass:"qrcode_bottom",staticStyle:{"text-align":"center"}},[_vm._v("手机扫一扫签名")])])
}
var staticRenderFns = []

export { render, staticRenderFns }